// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { add as fn } from "../add.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const addWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default addWithOptions;
